import store from '@/store'
import router from '@/router'
import localStore from '@/utils/localStore'
import {
    loginByPassword
} from '@/api/common/login'

/*
 * Function definition for login
 * api 2 pages below need to be modified for use
 * src/api/common/login.js [let apitest = true]
 * scr/store/modules/user.js [LoginByPassword => let isTest = true]
 */

// auto login check
export function fn_AutoLogin() {
    return Boolean(localStore.get('isAutoLogin'))
}

// log in
// [Object] userData (userId, userPw, comCode, isAutoLogin)
export function fn_Login(userData) {
    //console.log('userData', userData)
  
    return new Promise(function (resolve, reject) {
        let RESULT = {
            result: false,
            msg: 'Please enter your user information.'
        }
        // Create a loading start function
        //if (domainData.value !== '') {
            if (!userData.userId || userData.userId === '') {
                RESULT.result = false
                RESULT.msg = 'Input your ID.'
                resolve(RESULT)
                return
            }
            if (!userData.userPw || userData.userPw === '') {
                RESULT.result = false
                RESULT.msg = 'Input your Password.'
                resolve(RESULT)
                return
            }

            if (userData.userId == userData.userPw) {
                RESULT.result = false
                RESULT.msg = 'User ID is same Password! Please Change Password.'
                resolve(RESULT)
                return
            }

            let userInfo = {
                userId: userData.userId,
                userPw: userData.userPw,
                sysId: userData.sysId
                // comCode: userData.comCode,
                // isAutoLogin: userData.isAutoLogin
            }

            let map = ''           
            
            loginByPassword(userInfo).then(login_res => {
                // log-in succeed                
                if (login_res.success) {                    
                  if(login_res.map.msg) {
                    if(login_res.map.msg === 'id' || login_res.map.msg === 'pw') {
                      RESULT.result = false
                      RESULT.msg = 'loginFail'
                      resolve(RESULT)
                    //   console.log('Oanh userInfo RESULT', RESULT)  
                      return
                    }
                  }
                    //console.log('loginByPassword : ', login_res)
                    store
                        .dispatch('user/LoginByPassword', {
                            userInfo,
                            login_res
                        })
                        .then(response => {
                            store
                                .dispatch('user/SetUserInfo', {
                                    userId: userData.userId,
                                    userPw: userData.userPw
                                    // comCode: userData.comCode
                                })
                                .then(response => {
                                  // console.log('response : ', response)
                                    // store
                                    //     .dispatch('GetMenus', {
                                    //         userId: userData.userId,
                                    //         comCode: userData.comCode
                                    //     })
                                    //     .then(response => {

                                            RESULT.result = login_res.success
                                            RESULT.msg = login_res.msg
                                            resolve(RESULT)
                                            return
                                        // })
                                })
                        })
                        .catch(reject => {
                            RESULT.result = false
                            RESULT.msg = 'User information search failed. please contact the manager'
                            resolve(RESULT)
                            return
                        })                      
                } else {
                    RESULT.result = login_res.success
                    RESULT.msg = login_res.msg
                    resolve(RESULT)
                    return
                }
                    
            }).catch(error => {
              RESULT.result = false
              RESULT.msg = error.message
              resolve(RESULT)
              return
            })
       
    })
}

// Go to success page
export function fn_LoginSuccess(system) {
    // console.log('startPage',startPage) 
  
        router.push('/mainLayout')
        // router.push('/moceanLayout')
}

// 로그아웃
export function fn_Logout() {
    router.push('/logout')
}
